import { useContext } from 'react';
import { ComponentsContext } from './components-context';

export const useComponents = () => {
  return useContext(ComponentsContext);
};
